import React from 'react';
import { List, Comment, Avatar, Typography, Icon, Tooltip } from 'antd';
import { Link } from "react-router";
import DateViewer from '../DateViewer';

const { Paragraph } = Typography;

const MessageItem = ({
  chatData,
  handleChatChange,
  lastMessage,
  lastMessageDate,
  paramsId,
  uid,
  safeTofavoriteSwitcher,
  isChatFavorite
}) => {
  const haveUnreadMessages = {
    count: 0,
    newMessages: false
  };

  chatData.chat.forEach(message => {
    if (message.unread && message.userId !== uid) {
      haveUnreadMessages.newMessages = true;
      haveUnreadMessages.count++;
    }
  });

  const safeTofavorite = (event, chatId) => {
    event.stopPropagation();

    safeTofavoriteSwitcher(chatId);
  };

  const actions = [
    <span>
      <Tooltip title={isChatFavorite ? "Remove from favorite" : "Add to favorite"}>
        <Icon
          type="star"
          theme={isChatFavorite ? 'filled' : 'outlined'}
          style={{ fontSize: '16px' }}
          className={isChatFavorite ? 'active' : ''}
          onClick={(event) => safeTofavorite(event, chatData.chatId)}
        />
      </Tooltip>
    </span>
  ];

  return (
    <List.Item
      key={chatData.chatId}
      onClick={() => handleChatChange(chatData.chatId)}
      className={`chat-one ${chatData.chatId === paramsId ? 'chat-active' : ''}`}
    >
      <Link>
        <Comment
          className="chat-message"
          actions={actions}
          author={chatData.companionData.DisplayName}
          avatar={
            <Avatar
              src={chatData.companionData.PhotoUrl}
              alt={chatData.companionData.DisplayName}
              size={16}
            />
          }
          content={
            <Paragraph ellipsis={{ rows: 2, expandable: false }}>
              {lastMessage || 'loading...'}
            </Paragraph>
          }
          datetime={
            <div className={`${(haveUnreadMessages.newMessages) ? 'new-message' : ''}`}>
              {(haveUnreadMessages.newMessages)
                  ? "New Message"
                  : <DateViewer date={lastMessageDate} isExact/>
              }
            </div>
          }
        />
      </Link>
    </List.Item>
  )
};

export default MessageItem;



// WEBPACK FOOTER //
// ./src/components/Items/MessageItem.js